import { render, staticRenderFns } from "./viewMenuGroupInfo.vue?vue&type=template&id=1bb57d08&scoped=true"
import script from "./viewMenuGroupInfo.vue?vue&type=script&lang=js"
export * from "./viewMenuGroupInfo.vue?vue&type=script&lang=js"
import style0 from "./viewMenuGroupInfo.vue?vue&type=style&index=0&id=1bb57d08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb57d08",
  null
  
)

export default component.exports